<div class="card card-custom">
    <div class="card-body" *ngIf="!(loading$|async)">
        <div class="row">
            <div class="col-12">
                <div class="option-selector">
                    <mat-label class="font-weight-bolder">Comparables Overview</mat-label>
                    <mat-radio-group (change)="onComparableOverviewChange($event)" [value]="comparableOverview$|async">
                        <mat-radio-button [value]="'qualitative'">High Level</mat-radio-button>
                        <mat-radio-button [value]="'quantitative'">Detailed</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
        <ng-container *ngIf="comparableOverview$|async as overview">
            <ng-container *ngIf="overview === 'qualitative'">
                <app-comparables-table></app-comparables-table>
            </ng-container>
            <ng-container *ngIf="overview === 'quantitative'">
                <kt-sizes-table-v2
                    (removeComparable)="onRemoveComparable($event)"
                    (showComparable)="onShowComparable($event)"
                    (showComparableOverview)="onShowComparableOverview($event)"></kt-sizes-table-v2>
                <kt-criterions-table-v2
                    (removeComparable)="onRemoveComparable($event)"
                    (showComparable)="onShowComparable($event)"
                    (showComparableOverview)="onShowComparableOverview($event)"
                    ></kt-criterions-table-v2>
            </ng-container>
        </ng-container>

        <div class="row">
            <div class="col-12">
                <div class="option-selector">
                    <mat-label class="font-weight-bolder">Comparables analysis & adjustment</mat-label>
                    <mat-radio-group (change)="onComparableAnalysisChange($event)" [value]="comparableAnalysis$|async">
                        <mat-radio-button [value]="'qualitative'">Qualitative</mat-radio-button>
                        <mat-radio-button [value]="'quantitative'">Quantitative</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>

        <ng-container *ngIf="comparableAnalysis$|async as analysis">
            <ng-container *ngIf="analysis === 'qualitative'">
                <app-hampton-analysis></app-hampton-analysis>
            </ng-container>
            <ng-container *ngIf="analysis === 'quantitative'">
                <kt-adjustments-table-v2
                    (removeComparable)="onRemoveComparable($event)"
                    (showComparable)="onShowComparable($event)"
                    ></kt-adjustments-table-v2>
                <kt-valuation-table-v2
                    (removeComparable)="onRemoveComparable($event)"
                    (showComparable)="onShowComparable($event)"
                    (showComparableOverview)="onShowComparableOverview($event)"
                ></kt-valuation-table-v2>
            </ng-container>
        </ng-container>


    </div>
</div>